'use client';

import { useSyncExternalStore, type ReactNode } from 'react';
import { isEditModeSearch } from '@/app/_lib/edit-mode-url';

// The URL of a document never leaves or enters edit mode without a reload,
// so there is nothing to subscribe to.
const unsubscribe = () => undefined;
const subscribe = () => unsubscribe;
const isInEditor = () => isEditModeSearch(new URLSearchParams(window.location.search));
// On the server and while hydrating: render nothing, so the static HTML matches.
const isInEditorOnServer = () => true;

/**
 * Renders its children only outside the CMS's visual editor. Consent banners
 * and trackers have no place there: editors are not visitors, and a banner
 * would cover the content being edited.
 *
 * Decided on the client, since the root layout stays static (ISR) and the
 * editor is only recognizable by its URL. Fine for scripts that load after
 * hydration anyway.
 */
export function SkipInEditMode({ children }: { children: ReactNode }) {
  const inEditor = useSyncExternalStore(subscribe, isInEditor, isInEditorOnServer);
  return inEditor ? null : children;
}
